@if(ownedItemsList.length > 0) {
<div class="role__players--association--card mr-6 mb-3">
  <span class="app__template--linked--header">{{ headerText }}</span>
  <div class="flex flex-col gap-4 mt-3">
    @for (ownedItem of ownedItemsList; track ownedItem.key) {
    <common-ownership-table-view
      [title]="ownedItem.title"
      [records]="ownedItem.items"
      [tableConfig]="ownedItem.tableConfig"
      [categoryKey]="ownedItem.key"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      [showSelection]="isRemoveEditSaveSharing ? false : true"
      (onCellDataClickEventEmitter)="onCellDataClickEventEmitterHandler($event)"
      (onCheckboxSelectionChange)="onRolePlayerAssociationSelectionChange($event)"
    >
    </common-ownership-table-view>
    }
  </div>
</div>
}
